<template>
  <!-- 申请售后页面 -->
  <div class="contents">
    <div class="header">
      <van-nav-bar title="申请售后" left-arrow @click-left="$router.back()" />
    </div>
    <div class="center">
      <ul>
        <li>
          <!-- <div class="orderHeader">
            <span class="orderTitle">订单编号:{{ orderCode }}</span>
          </div> -->
          <div class="productInfo">
            <van-checkbox label-disabled>
              <van-card :title="productList.goods_detail_name" :thumb="productList.color_img">
                <template #tags>
                  <van-tag class="contentss">
                    <span>{{ productList.goods_desc }}</span></van-tag
                  >
                  <van-tag class="color">
                    <span>X{{ productList.num }}</span>
                  </van-tag>
                </template>
              </van-card>
            </van-checkbox>
          </div>
        </li>
      </ul>
      <van-tabs @change="handleClick" v-model="activeName">
        <van-tab name="apply" title="我要退货">
          <div class="reason">
            <van-form @submit="Apply" validate-first>
              <van-field
                class="reasonStyle"
                required
                :rules="[{ required: true, message: '请选择退货原因' }]"
                readonly
                clickable
                name="picker"
                :value="value"
                label="退货原因"
                placeholder="请选择"
                right-icon="arrow"
                input-align="right"
                error-message-align="right"
                @click="showPicker = true"
              />
              <van-field name="stepper" class="reasonNum" label="退货数量">
                <template #input>
                  <van-stepper
                    disable-input
                    v-model="stepper"
                    min="1"
                    :max="saleNum"
                  />
                  <a href="javascript:;">退换货政策</a>
                </template>
              </van-field>
              <van-cell
                title="退款金额"
                class="tkMoney"
                :value="
                  '￥' + Number(this.stepper * productList.oldPrice).toFixed(2)
                "
              />
              <van-cell title="退款方式" value="退至付款账户" />
              <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                />
              </van-popup>
              <div class="reason">
                <span class="refundExplain">退款说明(选填)</span>
                <van-field
                  v-model="message"
                  rows="2"
                  autosize
                  type="textarea"
                  maxlength="80"
                  placeholder="请说明原因"
                  show-word-limit
                />
              </div>
              <div class="fileImg">
                <span>上传凭证（选填，最多上传5张）</span>
                <van-uploader
                  v-model="fileList"
                  :after-read="afterRead"
                  :max-count="5"
                  :max-size="30000 * 1024"
                  :multiple="true"
                  @oversize="onOversize"
                  @delete="deleteImg"
                  preview-size="2.133333rem"
                >
                  <img src="../../assets/img/icon/组 10125@2x (1).png" alt="" />
                </van-uploader>
              </div>
              <div class="addresss">
                <div class="mobile">
                  <span class="nameLeft">退货方式</span>
                </div>
                <p>
                  <span
                    ><img src="../../assets/img/icon/组 7842@2x.png" alt=""
                  /></span>
                  自行寄回
                </p>
                <p class="Tips">
                  请自行联系快递寄回商品，宇起收到商品验货通过后进行后续退款
                </p>
              </div>
              <div class="address">
                <div class="mobile">
                  <span class="nameLeft">退货地址</span>
                </div>
                <p>
                  <img src="../../assets/img/icon/路径 3611@2x.png" alt="" />
                  宇起售后服务部 021-55220166
                </p>
                <p>
                  <img src="../../assets/img/icon/组 7843@2x.png" alt="" />
                  上海市黄浦区日月光中心3201室
                </p>
              </div>
              <van-button type="info" round native-type="submit"
                >提交申请</van-button
              >
            </van-form>
          </div>
        </van-tab>
        <van-tab name="record" title="我要换货">
          <div class="reason">
            <van-form @submit="exchangeApply" validate-first>
              <van-field
                class="reasonStyle"
                required
                :rules="[{ required: true, message: '请选择换货原因' }]"
                readonly
                clickable
                name="picker"
                :value="exchangeValue"
                label="换货原因"
                placeholder="请选择"
                right-icon="arrow"
                input-align="right"
                error-message-align="right"
                @click="exchangeShowPicker = true"
              />
              <van-field name="stepper" class="reasonNum" label="换货数量">
                <template #input>
                  <van-stepper
                    disable-input
                    v-model="exchangeStepper"
                    :max="saleNum"
                  />
                  <a href="javascript:;">退换货政策</a>
                </template>
              </van-field>
              <van-popup v-model="exchangeShowPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="exchangeColumns"
                  @confirm="exchangeOnConfirm"
                  @cancel="exchangeShowPicker = false"
                />
              </van-popup>
              <div class="reason">
                <span class="refundExplain">换货说明(选填)</span>
                <van-field
                  v-model="exchangeMessage"
                  rows="2"
                  autosize
                  type="textarea"
                  maxlength="80"
                  placeholder="请说明原因"
                  show-word-limit
                />
              </div>
              <div class="fileImg">
                <span>上传凭证（选填，最多上传5张）</span>
                <van-uploader
                  :after-read="exchangeAfterRead"
                  v-model="exchangeFileList"
                  :max-count="5"
                  :max-size="30000 * 1024"
                  :multiple="true"
                  @oversize="onOversize"
                  @delete="exchangeDeleteImg"
                  preview-size="2.133333rem"
                >
                  <img src="../../assets/img/icon/组 10125@2x (1).png" alt="" />
                </van-uploader>
              </div>
              <div class="addresss">
                <div class="mobile">
                  <span class="nameLeft">换货方式</span>
                </div>
                <p>
                  <span
                    ><img src="../../assets/img/icon/组 7842@2x.png" alt=""
                  /></span>
                  自行寄回
                </p>
              </div>
              <van-cell center title="收货地址">
                <template #right-icon>
                  <span class="addressInfo">与取件地址一致</span>
                  <van-switch
                    @change="exchange"
                    v-model="exchangeChecked"
                    size="24"
                  />
                </template>
              </van-cell>
              <div
                class="address"
                v-if="!exchangeChecked"
                @click="toOrderAddress"
              >
                <div class="mobile">
                  <span class="nameLeft">{{ AddressList.consignee }}</span>
                  <span class="mobileRight">{{ AddressList.mobile }} </span>
                  <van-icon name="arrow" />
                </div>
                <p>{{ AddressList.address_str }}</p>
              </div>
              <van-button type="info" round native-type="submit"
                >提交申请</van-button
              >
            </van-form>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 退货提醒 -->
    <van-action-sheet v-model="ActionSheetShow" title="退货提醒">
      <div class="content">
        <div class="tipsText">
          <van-icon name="checked" />
          <p class="zz">您已选择自寄退货</p>
          <h4 class="top">请填写回寄物流单号</h4>
          <p>请自行联系快递寄回商品，并及时填写 物流单号，以免影响退款进度</p>
          <h4>请确保退回商品及数量与申请单一致</h4>
          <p>请核对商品及数量与申请单一致，以免影响 退款进度</p>
          <h4>如果退货运费还有疑惑请联系我司售后</h4>
          <p>退货运费问题请先查看退换货政策</p>
        </div>
        <div class="operationBtn">
          <van-button
            class="modify"
            type="primary"
            @click="ActionSheetShow = false"
            >返回修改</van-button
          >
          <van-button
            :loading="LoadingShow"
            class="Submit"
            loading-text="正在提交"
            type="primary"
            @click="submitApply"
            loading-type="spinner"
            >提交退货</van-button
          >
        </div>
      </div>
    </van-action-sheet>
    <!-- 换货提醒 -->
    <van-action-sheet v-model="exchangeActionSheetShow" title="换货提醒">
      <div class="content">
        <div class="tipsText">
          <van-icon name="checked" />
          <p class="zz">您已选择自寄换货</p>
          <h4 class="top">请填写回寄物流单号</h4>
          <p>请自行联系快递寄回商品，并及时填写 物流单号，以免影响退款进度</p>
          <h4>请确保退回商品及数量与申请单一致</h4>
          <p>请核对商品及数量与申请单一致，以免影响 退款进度</p>
          <h4>如果退货运费还有疑惑请联系我司售后</h4>
          <p>退货运费问题请先查看退换货政策</p>
        </div>
        <div class="operationBtn">
          <van-button
            class="modify"
            type="primary"
            @click="exchangeActionSheetShow = false"
            >返回修改</van-button
          >
          <van-button
            :loading="exchangeLoadingShow"
            class="Submit"
            loading-text="正在提交"
            type="primary"
            @click="exchangeSubmitApply"
            loading-type="spinner"
            >提交换货</van-button
          >
        </div>
      </div>
    </van-action-sheet>
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="site" style="margin:50px 5px 5px 10px ">
        <!-- 收货地址页面 -->
        <div class="content-top">
          <div class="center-top">
            <van-address-list
              v-model="chosenAddressId"
              :list="list"
              default-tag-text="默认地址"
              round
              @add="onAdd"
              @edit="onEdit"
              @select="onfirmAddress"
            />
            <div class="odd" @click="onAdd()">新增地址</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 共用数据
      addressId: sessionStorage.getItem("_ADDRESS"),
      activeName: "apply",
      isMoney: true,
      ActionSheetShow: false,
      exchangeActionSheetShow: false,
      img: require("../../assets/img/duihao.png"),
      LoadingShow: false,
      exchangeLoadingShow: false,
      productList: {},
      // 地址信息
      AddressList: [],
      // 商品id
      record_detail_id: sessionStorage.getItem("Record_DetailId"),
      // 商品订单号
      orderCode: null,
      // 退货数据
      pattern: /^[^\u4e00-\u9fa5]+$/,
      value: "",
      columns: [
        "不想要了、错拍、多拍",
        "不喜欢、效果不好",
        "质量问题、商品故障",
        "商品破损、做工问题、包装问题",
        "商品与页面描述不符",
        "收到的商品少件（含少配件）",
        "其他",
      ],
      ReturnsNum: 0,
      saleNum: 0,
      stepper: 1,
      checked: true,
      showPicker: false,
      message: "",
      AddressShow: false,
      uploadImages: [],
      fileList: [],
      // 换货数据
      exchangeValue: sessionStorage.getItem("EXC")
        ? sessionStorage.getItem("EXC")
        : "",
      exchangeColumns: [
        "不喜欢、效果不好",
        "商家发错货",
        "质量问题、商品故障",
        "商品破损、做工问题、包装问题",
        "商品与页面描述不符",
        "收到的商品少件（含少配件）",
        "其他",
      ],
      exchangeStepper: 1,
      exchangeChecked: false,
      // exchangeChecked: sessionStorage.getItem("HAN")
      //   ? sessionStorage.getItem("HAN")
      //   : true,
      exchangeShowPicker: false,
      exchangeMessage: "",
      exchangeAddressShow: false,
      exchangeFileList: [],
      exchangeUploadImages: [],
      id: sessionStorage.getItem("EXCLUSIVE"),
      show: false,
      list: [],
      chosenAddressId: "1",
      isshow: false,
    };
  },
  mounted() {
    this.getProductList();
    this.getAddressList();
    this.getAddressList2();
    this.updateType();
  },
  methods: {
    toOrderAddress() {
      this.show = true;
    },
    // 收货地址切换
    exchange(value) {
      this.isshow = value;
    },
    updateType() {
      let type = location.search;
      //通过拿到的值不同，更改activeName的值
      if (type === "?type=1") {
        this.activeName = "apply";
      } else if (type === "?type=2") {
        this.activeName = "record";
      }
    },
    handleClick(tab) {
      let queryType;
      if (tab == "apply") {
        queryType = 1;
      } else if (tab == "record") {
        queryType = 2;
      }
      this.$router.replace({
        path: "/AfterSale",
        query: {
          type: queryType || 1,
        },
      });
    },
    // handleChange(value) {
    //   sessionStorage.setItem("HAN", value);
    // },
    toAddress() {
      sessionStorage.setItem("L_Y", this.messages);
      this.$router.push("/orderAddress");
    },
    // 获取订单信息
    async getProductList() {
      await this.$post({
        url: "oor/findOmsOrderRecordDetailInfo",
        method: "get",
        params: {
          // recordDetailId: this.$route.query.recordDetailId,
          recordDetailId: this.record_detail_id,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.saleNum = res.data.sale_num;
            this.ReturnsNum = res.data.num;
            this.orderCode = res.data.record_code;
            this.productList = res.data;
            // this.productList.content = this.productList.content.replace(
            //   /<[^>]+>/g,
            //   ""
            // );
          }
        })
        .catch((err) => {
          return;
        });
    },
    // 获取地址信息
    getAddressList() {
      this.$post({
        url: "/omsConsigneeAddress/findAll",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      }).then((res) => {
        if (res.retCode == 200) {
          this.AddressList = res.data.code[0];
        }
      });
    },
    // 上传图片
    afterRead(file) {
      if (file instanceof Array && file.length) {
        file.forEach((item) => {
          this.uploadImages.push(item.content);
        });
      } else {
        this.uploadImages.push(file.content);
      }
    },
    // 删除图片
    deleteImg(file, detail) {
      this.uploadImages = this.uploadImages.filter((item, index) => {
        return detail.index !== index;
      });
    },
    onOversize(file) {
      this.$toast("文件大小不能超过30M!");
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    // 弹窗
    async Apply() {
      this.ActionSheetShow = true;
    },
    // 提交退货申请
    async submitApply() {
      this.LoadingShow = true;
      await this.$post({
        url: "/saleService/apply",
        method: "post",
        dataType: "text",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        data: {
          // 用户id
          userId: sessionStorage.getItem("EXCLUSIVE"),
          // 订单号
          recordCode: this.orderCode,
          // 订单内商品id
          recordDetailId: this.record_detail_id,
          // 换货原因
          saleDesc: this.message,
          // 退货或者换货
          serviceMode: "退货",
          serviceReasionType: this.value,
          // 退货照片
          file: this.uploadImages,
          // 退货数量
          num: this.stepper,
          // 退货金额
          money: this.stepper * this.productList.oldPrice,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.$toast.success("申请成功");
            this.LoadingShow = false;
            this.$router.push("/refund");
          } else {
            this.LoadingShow = false;
            this.$toast.fail("申请失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 换货数据
    exchangeOnConfirm(value) {
      this.exchangeValue = value;
      sessionStorage.setItem("EXC", value);
      this.exchangeShowPicker = false;
    },
    // 上传图片
    exchangeAfterRead(file) {
      if (file instanceof Array && file.length) {
        file.forEach((item) => {
          this.exchangeUploadImages.push(item.content);
        });
      } else {
        this.exchangeUploadImages.push(file.content);
      }
    },
    // 删除图片
    exchangeDeleteImg(file, detail) {
      this.exchangeUploadImages = this.exchangeUploadImages.filter(
        (item, index) => {
          return detail.index !== index;
        }
      );
    },
    // 提交换货申请
    async exchangeApply() {
      this.exchangeActionSheetShow = true;
    },
    async exchangeSubmitApply() {
      this.exchangeLoadingShow = true;
      await this.$post({
        url: "/saleService/apply",
        method: "post",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        data: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          recordCode: this.orderCode,
          recordDetailId: this.record_detail_id,
          saleDesc: this.exchangeMessage, //说明
          serviceMode: "换货", //换货
          serviceReasionType: this.exchangeValue, //
          file: this.exchangeUploadImages, //图片
          num: this.exchangeStepper, //数量
          serviceUserName: this.isshow == true ? "" : this.AddressList.consignee,//姓名
          addressStr: this.isshow == true ? "" : this.AddressList.address_str, //地址
          mobile: this.isshow == true ? "" : this.AddressList.mobile, //电话
          money: this.exchangeStepper * this.productList.oldPrice, //退货金额
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.$toast.success("申请成功");
            this.exchangeLoadingShow = false;
            this.$router.push("/refund");
            if (this.$route.path == "/refund") {
              this.$router.go(0);
            }
          } else {
            this.exchangeLoadingShow = false;
            this.$toast.fail("申请失败");
          }
        })
        .catch((err) => {
          return false;
        });
    },
    //  地址数据
    onAdd() {
      this.$router.push({ path: "/addToAddress" });
    },
    onEdit(item) {
      this.$router.push({ path: "/editAddress", query: { id: item.id } });
      if (this.$route.path == "/editAddress") {
        this.$router.go(0);
      } else {
        return false;
      }
    },
    async getAddressList2() {
      sessionStorage.removeItem("AREA");
      await this.$post({
        url: "/omsConsigneeAddress/findAll",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            res.data.code.map((item) => {
              return this.list.push({
                id: item.address_id,
                name: item.consignee,
                tel: item.mobile,
                address: item.address_str,
                isDefault: item.first_choice == 1 ? true : false,
              });
            });
          }
          if (res.data.code.length == 0) {
            sessionStorage.removeItem("_ADDRESS");
          }
        })
        .catch((err) => {
          this.$toast("加载失败");
        });
    },
    // 跳转
    onfirmAddress(item) {
      sessionStorage.setItem("_ADDRESS", item.id);
      this.AddressList.consignee = item.name;
      this.AddressList.mobile = item.tel;
      this.AddressList.address_str = item.address;
      this.show = false;
    },
  },
};
</script>
<style lang="less" scoped>
.contents {
  width: 100%;
  overflow: hidden;
  position: relative;
  background: rgba(245, 245, 245, 1);
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #fff;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .center {
    margin: 0.56rem 0.27rem 0 0.27rem;
    background-color: #1f000000;
    padding-top: 0.83rem;
    ul {
      li {
        // height: 4.8rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.21rem;
        .orderHeader {
          height: 1.12rem;
          line-height: 1.12rem;
          border-bottom: 1px solid #eeeeee;
          .orderTitle {
            float: left;
            font-size: 0.38rem;
            margin-left: 0.27rem;
          }
          .refund {
            float: right;
            font-size: 0.42rem;
            margin-right: 0.37rem;
          }
          span {
            font-size: 0.45rem;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
        .productInfo {
          .van-checkbox {
            width: 100%;
            background-color: #ffffff;
            border-radius: 0.21rem;
            /deep/.van-checkbox__icon.van-checkbox__icon--round {
              display: none;
            }
          }
          .van-card {
            height: 2.75rem;
            // margin-top: 0.5rem;
            background-color: #ffffff;
            border-radius: 8%;
            .contentss {
              display: block;
              margin: 0.25rem 0 !important;
              width: 5rem;
              display: -webkit-box;
              // -webkit-box-orient: vertical;
              // -webkit-line-clamp: 1;
              overflow: hidden;
              color: #666;
            }
            .colors {
              display: block;
              color: #000 !important;
              font-size: 0.32rem;
            }
            .color {
              color: #666 !important;
              font-size: 0.32rem;
            }
            .van-card__content {
              margin-left: 0.3rem;
              .van-card__title.van-multi-ellipsis--l2 {
                margin-top: 0.2rem;
                font-size: 0.37rem;
              }
              .van-tag.van-tag--plain.van-tag--default.van-hairline--surround {
                .van-tag.van-tag--plain.van-tag--danger.van-hairline--surround {
                  color: #666;
                }
              }
            }
            .van-tag {
              padding: 0.2em 0.3em;
            }
            .van-tag--default {
              padding: 0;
              margin: 0;
              background-color: #fff;
            }
            .van-card__price {
              color: red;
            }
          }
        }
      }
    }
    .van-tabs {
      margin-top: 0.27rem;
    }
    .van-cell-group {
      .tkMoney {
        .van-cell__value {
          font-size: 0.37rem;
          color: #f74b2e;
        }
      }
    }
    .reason {
      /deep/.reasonStyle {
        input::-webkit-input-placeholder,
        textarea::-webkit-input-placeholder {
          color: #333;
        }
      }
      margin-top: 0.27rem;
      .van-cell__value {
        color: #333;
      }
      .tkMoney {
        .van-cell__value {
          color: #f74b2e;
        }
      }
      a {
        color: #f6a642;
        text-decoration: underline;
      }
      .van-cell {
        .van-cell__title {
          .van-cell__label {
            display: inline-block;
            width: 6rem;
          }
        }
      }
      .van-form {
        .reasonNum {
          margin-top: 0.27rem;
          /deep/.van-field__control {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }
      }
      .reason {
        margin-top: 0.27rem;
        background-color: #fff;
        .van-cell:not(:last-child)::after {
          border-bottom: none;
        }
        .van-cell.van-field {
          /deep/.van-cell__title.van-field__label {
            span {
              font-size: 0.37rem;
              color: #333;
              display: block;
            }
          }
        }
        .van-uploader {
          margin-left: 0.2rem;
        }
        .refundExplain {
          display: block;
          color: #333333;
          font-size: 14px;
          font-weight: 600;
          padding: 0.4rem 0 0 0.4rem;
        }
      }
      .fileImg {
        width: 9.5rem;
        margin-top: 0.27rem;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 0.3rem;
        img {
          width: 2.133333rem;
          height: auto;
        }
        span {
          display: block;
          font-size: 0.37rem;
          color: #333;
          margin: 0.4rem 0 0 0.4rem;
        }
        .van-uploader {
          margin-left: 0.4rem;
          margin-top: 0.5rem;
        }
      }
      .addresss {
        margin-top: 0.27rem;
        margin-bottom: 0.27rem;
        padding-bottom: 0.27rem;
        background-color: #fff;
        padding-top: 0.43rem;
        .nameLeft {
          display: block;
          margin: 0 0 0.4rem 0.34rem;
        }
        p {
          padding: 0.1rem 0.27rem;
          font-size: 0.4rem;
          span {
            img {
              width: 0.32rem;
              height: 0.32rem;
            }
          }
        }
        .Tips {
          color: #666666;
          font-size: 0.37rem;
        }
        .addressInfo {
          padding: 0.3rem 0.27rem;
        }
      }
      .address {
        position: relative;
        margin: 0 auto;
        margin-bottom: 0.27rem;
        background-color: #fff;
        .mobile {
          padding: 0.27rem 0.27rem 0.27rem 0.27rem;
          overflow: hidden;
          font-size: 0.4rem;
          .nameLeft {
            // float: left;
          }
          .mobileRight {
            line-height: 0.64rem;
            margin-left: 0.29rem;
            position: relative;
            // float: left;
            text-align: center;
            vertical-align: middle;
            color: #333;
            overflow: hidden;
          }
          .van-icon {
            color: #666666;
            position: absolute;
            top: 0.4rem;
            left: 8.4rem;
            font-size: 0.5rem;
            vertical-align: middle;
          }
        }
        p {
          width: 7.5rem;
          color: #999999;
          padding: 0.27rem;
          font-size: 0.4rem;
          img {
            width: 0.32rem;
            height: auto;
          }
        }
        .addressInfo {
          padding: 0.3rem 0.27rem;
        }
      }
      .van-switch {
        font-size: 0.48rem !important;
      }
      .addressInfo {
        margin-right: 0.2rem;
      }
      .van-button {
        margin-top: 1rem;
        margin-left: 50%;
        transform: translateX(-50%);
        width: 8rem;
        margin-bottom: 1rem;
        background-color: #fc563a;
        border-color: #fc563a;
      }
    }
    .van-cell.van-field {
      margin-top: 0.11rem;
    }
  }
  .content {
    padding: 0 0.5rem 0.5rem 0.5rem;
    overflow: hidden;
    .tipsText {
      .van-icon {
        width: 0.4rem;
        height: 0.4rem;
        display: inline-block;
        vertical-align: middle;
        color: #fc563a;
      }
      h4 {
        color: #000000;
        font-size: 0.373333rem;
      }
      .top {
        margin-top: 0.266667rem;
      }
      .zz {
        margin-left: 0.1rem;
        font-size: 0.37rem;
        display: inline-block;
        vertical-align: middle;
        color: #000;
        font-weight: 700;
      }
      p {
        line-height: 0.8rem;
        font-size: 0.373333rem;
        color: #666666;
        // font-size: 0.37rem;
        // margin: 0.3rem 0;
      }
    }
    .operationBtn {
      margin-top: 1rem;
      text-align: center;
      .modify {
        margin-right: 0.933333rem;
        height: 0.85rem;
        font-size: 0.32rem;
        border-radius: 1rem;
        background-color: #999999;
        border-color: #999999;
      }
      .Submit {
        margin-left: 0.933333rem;
        height: 0.85rem;
        font-size: 0.32rem;
        border-radius: 1rem;
        background-color: #fc563a;
        border-color: #fc563a;
      }
    }
  }
  .site {
    .center-top {
      height: 100%;
      background-color: #1f000000;
      .van-address-list {
        padding: 0;
        /deep/.van-address-item {
          .van-cell__value {
            .van-radio__icon.van-radio__icon--round {
              display: none;
            }
          }
        }
      }
      .van-checkbox {
        background-color: #ffffff;
        border-radius: 0.21rem;
        margin-bottom: 0.27rem;
        /deep/.van-checkbox__icon.van-checkbox__icon--round {
          display: none;
        }
      }
      .van-card {
        width: 22.1875rem;
        height: 2.75rem;
        margin-top: 0.5rem;
        float: right;
        background-color: #ffffff;
        border-radius: 8%;
        .van-card__content {
          margin-left: 0.5rem;
          .van-tag.van-tag--plain.van-tag--default.van-hairline--surround {
            font-size: 0rem;
            .van-tag.van-tag--plain.van-tag--danger.van-hairline--surround {
              color: #ccc;
            }
          }
          .van-button {
            margin-left: 3.5rem;
            display: block;
            border-radius: 0.11rem;
          }
        }
        .van-tag {
          padding: 0.2em 0.3em;
        }
        .van-tag--default {
          background-color: #fff;
        }
        .van-tag.van-tag--default {
          color: #ccc;
        }
        .van-card__price {
          color: red;
        }
      }
      .odd {
        text-align: center;
        height: 1.0667rem;
        max-width: 3rem;
        margin: 0 auto;
        line-height: 1.0667rem;
        font-size: 0.48rem;
        color: white;
        padding: 0 2rem;
        background-color: #ee0a24;
        border-radius: 1rem;
      }
    }
    /deep/.van-address-list__bottom {
      display: none;
    }
  }
}
</style>
